module.exports = __webpack_public_path__ + "static/image-04-a@2x-79ad2e4c85bfc5c7eb7eac201f37f563.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/mode/image-04-a@2x.jpg
// module id = 398
// module chunks = 3627797113349 20562973939449 33019919093843